<template>
  <div class="props-group">
    <el-form-item label="禁止粘贴">
      <el-checkbox v-model="component.properties.disablePaste"></el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: ['component'],
  name: 'disable-paste'
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/disable-paste.vue